import {
    CADASTRAR_USUARIOS_EMPRESA_EM_LOTE,
    LIMPAR_RETORNO_CADASTRAMENTO_USUARIO_EMPRESA_EM_LOTE,
    HABILITADO_PAGAMENTO_POS, HABILITADO_PAGAMENTO_TEF, HABILITADO_PAGAMENTO_LINK,
    HABILITADO_CIELO_ECOMMERCE, HABILITADO_SICOOB, HABILITADO_STONE_CONNECT
} from '../../actions/types'

const initialState = {
    retornoCadatramentoEmLote: null,
    habilitadoPagamentoViaPOS: false,
    habilitadoPagamentoViaTEF: false,
    habilitadoPagamentoViaLink: false,
    habilitadoCieloEcommerce: false,
    habilitadoSicoob: false,
    habilitadoStoneConnect: false
};


export default function reducerUsuariosEmpresa(state = initialState, action) {

    switch (action.type) {
        case CADASTRAR_USUARIOS_EMPRESA_EM_LOTE: {
            return {
                ...state,
                retornoCadatramentoEmLote: action.payload.data,
            }
        }

        case HABILITADO_PAGAMENTO_POS: {
            return {
                ...state,
                habilitadoPagamentoViaPOS: action.payload.data
            }
        }

        case HABILITADO_PAGAMENTO_TEF: {
                    return {
                        ...state,
                        habilitadoPagamentoViaTEF: action.payload.data
                    }
                }

        case HABILITADO_PAGAMENTO_LINK: {
            return {
                ...state,
                habilitadoPagamentoViaLink: action.payload.data
            }
        }
        
        case HABILITADO_CIELO_ECOMMERCE: {
            return {
                ...state,
                habilitadoCieloEcommerce: action.payload.data
            }
        }

        case HABILITADO_SICOOB: {
            return {
                ...state,
                habilitadoSicoob: action.payload.data
            }
        }

        case HABILITADO_STONE_CONNECT: {
            return {
                ...state,
                habilitadoStoneConnect: action.payload.data
            }
        }

        case LIMPAR_RETORNO_CADASTRAMENTO_USUARIO_EMPRESA_EM_LOTE: {
            return {
                ...state,
                retornoCadatramentoEmLote: null
            }
        }

        default: {
            return state
        }
    }
}
